interface HomeModesFocusDetail {
  stepIndex: number;
  resolve: () => void;
  reject: (error?: unknown) => void;
}

const EVENT_NAME = "homeModesFocusRequest";

/**
 * Request HomeCanvas to focus the hotspot for a given homeModesTour step
 * before showing the tour card. Resolves even if no listener is mounted to
 * avoid blocking the tour flow.
 */
export function requestHomeModesFocus(stepIndex: number): Promise<void> {
  if (typeof window === "undefined") {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const fallback = window.setTimeout(() => resolve(), 1500);

    const detail: HomeModesFocusDetail = {
      stepIndex,
      resolve: () => {
        window.clearTimeout(fallback);
        resolve();
      },
      reject: (error) => {
        window.clearTimeout(fallback);
        reject(error);
      },
    };

    window.dispatchEvent(new CustomEvent<HomeModesFocusDetail>(EVENT_NAME, { detail }));
  });
}

export type { HomeModesFocusDetail };
export { EVENT_NAME as HOME_MODES_FOCUS_EVENT };
